import axios from "axios";
import useAppStore from "../../store/useAppStore";
import { API_CONFIG } from "../config/apiConfig";
import { showGlobalToast } from "../../utils/toastService";
import { ENDPOINTS } from "../config/endpoints";
import { navigate } from "../../utils/navigationService";
import { ROUTES } from "../../routes/routePaths";

const apiClient = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: API_CONFIG.DEFAULT_HEADERS,
});

apiClient.interceptors.request.use(
  async (config) => {
    const { userToken, appDetails, locationDetails } = useAppStore.getState();

    if (userToken) {
      config.headers["_ta"] = userToken;
    }

    const latitude = locationDetails?.latitude || null;
    const longitude = locationDetails?.longitude || null;

    config.params = {
      ...config.params,
      v: appDetails?.versionCode || 4000,
      latitude,
      longitude,
      cacheBuster: Date.now(),
    };
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const {
        refreshToken: storedRefreshToken,
        storeUserTokens,
        clearAuth,
      } = useAppStore.getState();
      if (storedRefreshToken) {
        try {
          const response = await axios.post(
            `${API_CONFIG.BASE_URL}${ENDPOINTS.REFRESH_TOKEN}`,
            {},
            { headers: { _tr: storedRefreshToken } }
          );
          if (response?.data?.results) {
            let { _ta, _tr } = response.data.results[0].properties ?? {};
            storeUserTokens(_ta, _tr);
            originalRequest.headers["_ta"] = _ta;
            return apiClient(originalRequest);
          }
        } catch (err) {
          clearAuth();
          showGlobalToast("Session expired. Please login again.", {
            type: "error",
          });
          navigate(ROUTES.HOME);
          return Promise.reject(err);
        }
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
